/* sucrase/dist/esm/util/isExportFrom.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.default = isExportFrom;
    const keywords_1 = require("99ff836c64") /* ../parser/tokenizer/keywords */;
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    /**
     * Starting at `export {`, look ahead and return `true` if this is an
     * `export {...} from` statement and `false` if this is a plain multi-export.
     */
    function isExportFrom(tokens) {
        let closeBraceIndex = tokens.currentIndex();
        while (!tokens.matches1AtIndex(closeBraceIndex, types_1.TokenType.braceR)) {
            closeBraceIndex++;
        }
        return (tokens.matchesContextualAtIndex(closeBraceIndex + 1, keywords_1.ContextualKeyword._from) &&
            tokens.matches1AtIndex(closeBraceIndex + 2, types_1.TokenType.string));
    }
}
